import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";

export { machineEpromConfigurationObjectName as vsObjectName } from "../../shared/names";
import {
  machineConfigurationObjectName,
  machineEpromConfigurationObjectName,
} from "../../shared/names";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsServiceName as ColumnDefinitionSetServiceName,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";

machineEpromConfigurationConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineEpromConfigurationConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    machineEpromConfigurationObjectName,
    [
      ServerUtilityName,
      GridSettingsServiceName,
      RecordGridViewServiceName,
      (
        serverUtility: ServerUtility,
        gridSettingsService: GridSettingsService,
        recordGridViewService: RecordGridViewService
      ): GridConfiguration => {
        const machineConfigurationGridConfig =
          recordGridViewService.getGridConfiguration(
            machineConfigurationObjectName
          );

        return {
          columnDefinitionSet: machineEpromConfigurationObjectName,
          defaultSort: machineConfigurationGridConfig?.defaultSort,
          gridDataSource: new RecordDataSource(
            serverUtility,
            "/api/machines/MachineEpromConfiguration"
          ),
          gridSettings: gridSettingsService.getGridSettings(
            Symbol(machineEpromConfigurationObjectName)
          ),
          nameSingular: "Game Software",
          namePlural: "Game Software",
          showAddButton: false,
        };
      },
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    machineEpromConfigurationObjectName,
    [
      ColumnDefinitionServiceName,
      ColumnDefinitionSetServiceName,
      (
        columnDefinitionService: ColumnDefinitionService,
        columnDefinitionSetService: ColumnDefinitionSetService
      ) => {
        return [
          columnDefinitionService.getStringColDef({
            field: "EpromType",
            header: "EPROM Type",
          }),
          columnDefinitionService.getStringColDef({
            field: "EpromLabel",
            header: "EPROM Label",
          }),
          columnDefinitionService.getStringColDef({
            field: "EpromVersion",
            header: "EPROM Version",
          }),
          ...columnDefinitionSetService.getColumnDefinitionSet(
            machineConfigurationObjectName
          ),
        ];
      },
    ]
  );
}
